<template>
    <div id="OrderIndex">
        <div class="top">
            <p class="topL">欢迎访问畅通圆！</p>
            <div class="topR">
                <el-menu :default-active="activeIndex" class="el-menu-demo fr personal geNav" mode="horizontal"
                    :router="true" @select="handleSelect">
                    <!-- <el-menu-item
                        index="/ysRegister"
                        v-if="!isYS"
                        :class="displayNone?'displayNoneClass':''"
                    >{{ysWords}}</el-menu-item> -->
                    <el-menu-item index="/doctorInfo" v-if="userInfo.userType == 1"
                        @click="ZCrefresh(1)">医师注册</el-menu-item>
                    <el-menu-item index="/wholesalerInfo" v-if="userInfo.isMerchant == 0"
                        @click="ZCrefresh(0)">批发商注册</el-menu-item>
                    <el-menu-item index="/login" v-if="login">登录</el-menu-item>
                    <el-menu-item index="/register" v-if="login">注册</el-menu-item>

                    <el-submenu index="2" v-if="!login">
                        <template slot="title">
                            <p class="HeadPortrait">
                                <img :src="$store.state.imgUrl + userInfo.headImg" alt />
                            </p>
                            <span>{{ userInfo.realName ? userInfo.realName : '游客' }}</span>
                        </template>

                        <el-menu-item @click="signOut()">退出</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4" v-if="!login">
                        <template slot="title">我的信息</template>
                        <el-menu-item index="/PersonalCenter" @click="refresh()" v-if="!isYS">个人中心</el-menu-item>
                        <el-menu-item index="/personalFiles" @click="refresh()" v-else>个人中心</el-menu-item>
                        <el-menu-item index @click.native="editPassword">修改密码</el-menu-item>
                    </el-submenu>

                    <el-submenu index="5">
                        <template slot="title">手机版</template>
                        <el-menu-item index class="erweimaSJ">
                            <div>
                                <img src="../../assets/img/ma2.png" alt style="width:100px;height:100px" />
                            </div>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="6" v-if="!isYS">
                        <template slot="title">网站导航</template>
                        <el-menu-item index="/index">首页</el-menu-item>
                        <el-menu-item index @click="zizhen()">中医自测</el-menu-item>
                        <el-menu-item index="/ForumIndex">中医讲堂</el-menu-item>
                        <el-menu-item index="/ancPre">古方大全</el-menu-item>
                        <el-menu-item index="/HerbalMedicineIndex">中草药</el-menu-item>
                        <el-menu-item index="/LibraryIndex">中医文库</el-menu-item>
                        <el-menu-item index="/JingLuoIndex">经络穴位</el-menu-item>
                        <el-menu-item index="/ShopIndex">药城</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </div>
        <router-view />
        <div class="foot">
            <p>©2019畅通圆公司版权所有 青ICP备19001322号</p>
        </div>
        <!-- <div class="btmNav">
            <ul>
                <li>畅通圆</li>
                <li>中医自测</li>
                <li>中医讲堂</li>
                <li>中草药</li>
                <li>中医文库</li>
                <li>经络穴位</li>
            </ul>
        </div>-->
        <!-- <vfooter></vfooter> -->
        <!-- <footerCopy></footerCopy> -->

        <el-dialog custom-class="small-dialog-box" title="修改密码" :close-on-click-modal="false"
            v-if="dialogData.dialogFormVisible" :visible.sync="dialogData.dialogFormVisible" center width="400px">
            <el-form :model="dialogData.form" label-width="80px" :rules="rules" ref="form">
                <el-form-item label="旧密码" prop="oldpassword">
                    <el-input size="small" type="password" v-model.trim="dialogData.form.oldpassword"
                        autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newpassword">
                    <el-input size="small" type="password" v-model.trim="dialogData.form.newpassword"
                        autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="sureNew">
                    <el-input size="small" type="password" v-model.trim="dialogData.form.sureNew"
                        autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogData.dialogFormVisible = false">取 消</el-button>
                <el-button size="small" type="danger" @click="submitDialog('form')" class="red">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import footerCopy from "@/components/common/footerCopy";
export default {
    name: "Shopping",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.dialogData.form.sureNew !== "") {
                    this.$refs.form.validateField("sureNew");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.dialogData.form.newpassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            rules: {
                oldpassword: [
                    { required: true, message: "请输入旧密码", trigger: "blur" }
                ],
                newpassword: [
                    { validator: validatePass, trigger: "blur" },
                    {
                        required: true,
                        message: "请输入新密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ],
                sureNew: [
                    { validator: validatePass2, trigger: "blur" },
                    {
                        required: true,
                        message: "请输入确定密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }
                ]
            },
            activeIndex: "1",
            userInfo: {},
            login: true, //是否显示登陆,注册按钮
            dialogData: {
                dialogFormVisible: false,
                form: {
                    id: "",
                    oldpassword: "",
                    newpassword: "",
                    sureNew: ""
                }
            },
            displayNone: false,
            ysWords: "医师注册"
        };
    },
    components: {
        topHead: topHead,
        vfooter: vfooter,
        footerCopy: footerCopy
    },
    created() {
        let that = this;
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            if (this.userInfo.id) {
                this.login = false;
            } else {
                this.login = true;
            }
            if (this.userInfo.userType == 2) {
                this.displayNone = true;
            } else {
                this.displayNone = false;
            }
            if (JSON.parse(sessionStorage.getItem("YS"))) {
                this.isYS = JSON.parse(sessionStorage.getItem("YS"));
            } else {
                that.ysWords = "医师申请";
            }
        } else {
            that.ysWords = "医师注册";
        }
    },
    methods: {
        refresh() {
            //个人中心刷新
            this.i1 = sessionStorage.setItem("leftIndex1", 100);
            this.i2 = sessionStorage.setItem("leftIndex2", 100);
            this.i3 = sessionStorage.setItem("leftIndex3", 100);
            this.i4 = sessionStorage.setItem("leftIndex4", 100);
            // // 刷新兄弟组件
            let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
            this.$router.push(NewPage);
            this.$router.go(-1);
        },
        ZCrefresh(index) {
             //个人中心刷新
             this.i1 =sessionStorage.setItem("leftIndex1", 100); //左侧导航位置
             this.i2 =sessionStorage.setItem("leftIndex2", 100); //左侧导航位置
             this.i3 =sessionStorage.setItem("leftIndex3", 100); //左侧导航位置
             this.i4 =sessionStorage.setItem("leftIndex4", index); //左侧导航位置
             
            // // 刷新兄弟组件
            let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
            this.$router.push(NewPage);
            this.$router.go(-1);
        },
        //修改密码
        editPassword() {
            this.dialogData.dialogFormVisible = true;
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        //退出登陆
        signOut() {
            let that = this;
            let url = "/user/saveLastOnlineTime";
            let params = {
                id: that.userInfo.id
            };
            that.$http
                .post(url, params)
                .then(res => {
                    if (res.data.code == 200) {
                        sessionStorage.clear();
                        that.login = true;
                        if (JSON.parse(sessionStorage.getItem("YS"))) {
                            that.$router.replace({
                                path: "/ysLogin"
                            });
                        } else {
                            that.$router.replace({
                                path: "/login"
                            });
                        }

                        // 刷新兄弟组件
                        let NewPage =
                            "_empty" + "?time=" + new Date().getTime() / 500;
                        this.$router.push(NewPage);
                        this.$router.go(-1);
                    } else {
                        that.$message(res.data.msg);
                    }
                })
                .catch(() => {
                    that.$message("网络错误！");
                });
        }
    }
};
</script>
<style scoped>
#OrderIndex {
    background: #f6f6f6;
}

.top {
    height: 30px;
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    margin: 0px auto;
}

.topL {
    height: 30px;
    line-height: 30px;
    width: 20%;
    float: left;
    font-size: 13px;
    letter-spacing: 2px;
    color: #666666;
}

.topR {
    float: right;
    width: 55%;
    height: 30px;
}

.HeadPortrait {
    float: left;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
}

.HeadPortrait img {
    max-width: 100%;
    min-height: 100%;
}

.btmNav {
    width: 100%;
    height: 50px;
    background: #eee;
    border-top: 1px solid #f6f6f6;
    border-bottom: 1px solid #f6f6f6;
    margin-top: 100px;
}

.btmNav ul {
    width: 900px;
    height: 50px;
    margin: 0px auto;
}

.btmNav ul li {
    float: left;
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    margin: 0 30px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
}

.displayNoneClass {
    display: none;
}

.Product {
    width: 100%;
    height: 45%;
    background: #fff;
    margin-top: 10px;
}

.Product .p1 {
    width: 100%;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}

.Product .p1 .tit {
    display: block;
    float: left;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #909090;
}

.Product .p1 .tit2 {
    display: block;
    float: right;
    height: 20px;
    line-height: 20px;
    width: 40px;
    text-align: center;
    border: 1px solid #f74320;
    background: #ffece8;
    margin-right: 10px;
    color: #f74320;
}

.Product .p1 .tit22 {
    border: 1px solid #64b9f2;
    background: #e8f7fe;
    color: #64b9f2;
}

.Product .p2 {
    height: 40px;
    line-height: 20px;
    color: #666;
    margin-top: 5px;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.Product .p3 {
    width: 100%;
    height: 25px;
    /* margin-top: 20px; */
}

.Product .p3 .money {
    float: left;
    width: 60%;
    text-indent: 10px;
}

.p3 .money span {
    color: #f74320;
    font-size: 25px;
    font-weight: 600;
}

.p3 .money i {
    color: #999;
    font-size: 16px;
    font-style: normal;
}

.Product .p3 .car {
    float: right;
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    margin-right: 20px;
    background: #f74320;
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
}
</style>

<style>
.el-menu {
    background: transparent;
}

.el-menu.el-menu--horizontal {
    height: 30px;
}

.personal>.el-submenu .el-submenu__title {
    height: 30px !important;
    line-height: 30px !important;
}

.topR .el-menu--horizontal>.el-menu-item {
    height: 30px !important;
    line-height: 30px !important;
}

#Shopping {
    background: #fbfbfb;
}

.bottomW {
    background-color: #fbfbfb;
}

/* 上方商品分类选项 */
.topList {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
}

.topList h3 {
    float: left;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #ffa42f;
    margin: 0;
    cursor: pointer;
    position: relative;
}

.topList-list {
    width: 150px;
    min-height: 350px;
    max-height: 500px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 999;
    overflow-y: auto;
}

.topList-list ul {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
}

.topList-list ul li {
    width: 100%;
    height: 35px;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    font-weight: 100;
    border-bottom: 1px dashed #999;
}

.topList-list ul li span {
    height: 35px;
    line-height: 35px;
    display: block;
    width: 90%;
    float: left;
    text-align: left;
}

.topList-list ul li i {
    height: 35px;
    line-height: 35px;
    display: block;
    width: 10%;
    float: left;
}

.topList .nav {
    float: left;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 1px;
    color: #666666;
}

.topList .nav li {
    float: left;
    padding: 0 10px;
    cursor: pointer;
}

/* 主题内容 */
.main {
    width: 100%;
    margin: 0px auto;
}

.main::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}

.content {
    width: 100%;
}

.content::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}

/* 底部  */
.foot {
    /* width: 100%; */
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    letter-spacing: 1px;
    color: #999999;
    text-align: center;
    /* border: 1px solid #ddd; */
    margin-top: 60px;
    position: fixed;
    bottom: 0px;
    background-color: #f6f6f6;
    width: 100%;
}

/* 商品列表样式 */
.Product1,
.Product2 {
    width: 100%;
}

.Product1::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}

.Product2::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}

.ProductList {
    float: left;
    width: 24%;
    height: 340px;
    margin: 20px 13px 0 0;
}

.ProductList2 {
    float: left;
    width: 18.7%;
    height: 290px;
    margin: 15px 13px 0 0;
}

.ProductList:nth-child(4n + 4) {
    margin-right: 0;
}

.ProductList2:nth-child(4n + 4) {
    margin-right: 13px;
}

.ProductList2:nth-child(5n + 5) {
    margin-right: 0;
}

.ProductList .ProductImg {
    width: 100%;
    height: 50%;
    overflow: hidden;
    text-align: center;
}

.ProductImg img {
    width: 100%;
    min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ShoppingMall/OrderIndex.vue